// extracted by mini-css-extract-plugin
export default {"skill_block":"ResumeSkills_skill_block__wglrr","skill_item":"ResumeSkills_skill_item__Z-q5S"};